import { Pipe, PipeTransform } from '@angular/core';
import { Category } from '@interfaces/Category';

@Pipe({
  name: 'categoryTotalHours'
})
export class CategoryTotalHoursPipe implements PipeTransform {
  public transform(category: Category): number {
    let total = 0;

    for (const estimateLine of category.estimateLines) {
      for (const classificationLine of estimateLine.classificationLines) {
        total += classificationLine.hours;
      }
    }

    return total;
  }
}
